import { styled } from "@mui/material";

interface Data {
    country: string;
}

const CountryDetails: React.FC<Data> = ( {country} )  => {
    return (
        <>
            <StyledContainer>
                {/* <StyledWrapper>
                    <StyledText>Status</StyledText>
                    <Active>Active</Active>
                </StyledWrapper> */}
                <StyledWrapper>
                    <StyledText>Country</StyledText>
                    <StyledDate>{country}</StyledDate>
                </StyledWrapper>
            </StyledContainer>
        </> 
    );
};

export default CountryDetails;

const StyledContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding-block-start: 1.8rem;
    padding-block-end: 5rem;
    padding-inline: 2rem;
`

const StyledWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
`

const DetailText = styled('span')`
    font-weight: 600;
    font-size: 1.6rem;
    margin-inline: 0.8rem;
    margin-block-start: 2rem;
    margin-inline-start: 2rem;
`

const StyledText = styled('span')`
    font-size: 24px;
    font-weight: 400;
    color: #4E5A62;
`

const Active = styled('span')`
    font-size: 16px;
    font-weight: 500;
    background-color: #E0FAEE;
    border-radius: 0.4rem;
    padding-inline: 2rem;
    padding-block: 0.5rem;
    color: #11643C;
`

const StyledDate = styled(StyledText)`
    color: #020D08;
    font-weight: 500;
`